import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import SessionService from "../Services/SessionService";

interface BrokenLinkDialogProps {
  shareholderId?: any;
  currentFiscalYearId?: any;
  visible: boolean;
  header?: string;
  message?: string;
  subject?: string;
  showSupportButton?: boolean;
  showHomeButton?: boolean;
  onRedirect?: () => void;
}

const BrokenLinkDialog = ({
  shareholderId,
  currentFiscalYearId,
  visible,
  header = "Something went wrong",
  message = "We can not find the plan you are looking for. If you need assistance, please request support.",
  subject = "Apex: unable to load Plan",
  showSupportButton = true,
  showHomeButton = true,
  onRedirect,
}: BrokenLinkDialogProps) => {

  const role = SessionService.getRole();    

  const handleSupportClick = () => {
    //SessionService.clearSHId();
    const body = shareholderId && currentFiscalYearId ? `Shareholder ID: ${shareholderId}\nFiscalYear ID: ${currentFiscalYearId}` : "";
    const mailtoLink =
      "mailto:help@lbmc.com" +
      "?cc=DigitalProductTeam@lbmc.com" +
      "&subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);
    window.location.href = mailtoLink;
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={() => onRedirect && onRedirect()}
      className="error-dialog"
      style={{ width: "520px" }}
      closable={false}
    >
      <div className="p-mb">
        <p className="text-lg font-medium mt-0">{message}</p>
        {
          role != "Shareholder" && (shareholderId && currentFiscalYearId) ? (
            <div>
              <p>Shareholder & FiscalYear ID:</p>{" "}
              <InputTextarea
                readOnly
                //value={`${shareholderId}\n${currentFiscalYearId}`}
                value={`${shareholderId ?? ""}${shareholderId && currentFiscalYearId ? "\n" : ""}${currentFiscalYearId ?? ""}`}
                style={{ width: "100%" }}
                className="text-sm error-textarea"
                autoResize
                rows={5}
                cols={30}
              />
            </div>
          ) : (<></>)
        }        
      </div>

      <div className="flex justify-content-end mt-4">
        {showSupportButton && (
          <Button
            outlined
            label="Request Support"
            className="rounded mr-2"
            onClick={handleSupportClick}
          />
        )}

        {showHomeButton && (
          <Button
            label="Return to Home"
            className="rounded"
            onClick={onRedirect}
          />
        )}
      </div>
    </Dialog>
  );
};

export default BrokenLinkDialog;
